import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import account from './account/account.routes';
import agent from './agents/agent.routes';
import assignmentPolicy from './assignmentPolicy/assignmentPolicy.routes';
import automation from './automation/automation.routes';
import billing from './billing/billing.routes';
import canned from './canned/canned.routes';
import faqMenu from './faqMenu/faqMenu.routes';
import inbox from './inbox/inbox.routes';
import kefubaoPhrases from './kefubaoPhrases/kefubaoPhrases.routes';
import labels from './labels/labels.routes';
import localBot from './localBot/localBot.routes';
import reports from './reports/reports.routes';
import store from '../../../store';
import teams from './teams/teams.routes';
import profile from './profile/profile.routes';
import conversationWorkflow from './conversationWorkflow/conversationWorkflow.routes';
import vipLevels from './vipLevels/vipLevels.routes';
import vipAssignment from './vipAssignment/vipAssignment.routes';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      meta: {
        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      },
      redirect: to => {
        if (
          store.getters.getCurrentRole === 'administrator' &&
          store.getters.getCurrentCustomRoleId === null
        ) {
          return { name: 'general_settings_index', params: to.params };
        }

        return { name: 'canned_list', params: to.params };
      },
    },
    ...account.routes,
    ...agent.routes,
    ...assignmentPolicy.routes,
    ...automation.routes,
    ...billing.routes,
    ...canned.routes,
    ...faqMenu.routes,
    ...inbox.routes,
    ...kefubaoPhrases.routes,
    ...localBot.routes,
    ...labels.routes,
    ...reports.routes,
    ...teams.routes,
    ...profile.routes,
    ...conversationWorkflow.routes,
    ...vipLevels.routes,
    ...vipAssignment.routes,
  ],
};
